module.exports = __webpack_public_path__ + "media/images/illustrations/skie_logo_all_blue-5f8b63ebcb40448b9af4dcd50f5643c6.png";